import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-slate-400 border-t border-slate-800/60">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {/* Brand Column */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3 group">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/height=240,format=auto/assets/cf131c5c-877c-4f32-8100-a69e4d795732/k-logo.png"
                alt="K. Pheiffer Construction Logo"
                className="h-20 md:h-24 w-auto object-contain transition-transform duration-300"
              />
            </Link>
            <p className="text-sm text-slate-400 max-w-xs">
              Professionelt og pålideligt tømrerarbejde i Fredericia og omegn. Vi bygger på kvalitet og tillid.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">Navigation</h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-white transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/jeg-tilbyder" className="text-sm hover:text-white transition-colors">
                  Jeg tilbyder
                </Link>
              </li>
              <li>
                <Link to="/kunderne-siger" className="text-sm hover:text-white transition-colors">
                  Kunderne siger
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="text-sm hover:text-white transition-colors">
                  Galleri
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="text-sm hover:text-white transition-colors">
                  Om os
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-sm hover:text-white transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">Virksomhedsoplysninger</h3>
            <ul className="mt-4 space-y-3">
              <li className="flex items-start gap-3">
                <i className="fa-regular fa-location-dot text-emerald-500 mt-1" />
                <span className="text-sm text-slate-300">
                  K. Pheiffer Construction<br />
                  Snaremosevej 23H<br />
                  7000 Fredericia
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-phone text-emerald-500" />
                <a
                  href="tel:+4560183562"
                  className="text-sm text-slate-300 hover:text-white transition-colors whitespace-nowrap"
                >
                  60 18 35 62
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-envelope text-emerald-500" />
                <a
                  href="mailto:kontakt@kpheiffer.dk"
                  className="text-sm text-slate-300 hover:text-white transition-colors whitespace-nowrap"
                >
                  kontakt@kpheiffer.dk
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-slate-800/60 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            &copy; {currentYear} K. Pheiffer Construction. Alle rettigheder forbeholdes.
          </p>
          <p className="text-xs text-slate-600">
            CVR: 42193812 · Udviklet med fokus på kvalitet
          </p>
        </div>
      </div>
    </footer>
  );
}
